"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideTomato = void 0;
var React = require("react");
var Card_1 = require("../TomatoCard/Card");
var Arrow_1 = require("./Arrow");
var utils_1 = require("../utils");
var utils_2 = require("./utils");
var styled_1 = require("./styled");
var SlideTomato = (function (_super) {
    __extends(SlideTomato, _super);
    function SlideTomato(props) {
        var _this = _super.call(this, props) || this;
        _this.onQueueBack = function () {
            _this.setState(function () {
                var nextQueue = __spreadArrays(_this.state.queue);
                var nextTopFive = __spreadArrays(nextQueue.slice(-_this.state.step));
                nextQueue = __spreadArrays(nextTopFive, nextQueue.slice(0, nextQueue.length - _this.state.step));
                return {
                    queue: nextQueue,
                    renderPage: utils_2.RenderPage.Center
                };
            });
        };
        _this.onQueueNext = function () {
            _this.setState(function () {
                var nextQueue = __spreadArrays(_this.state.queue);
                var top = nextQueue.slice(0, _this.state.step);
                nextQueue.splice(0, _this.state.step);
                nextQueue = __spreadArrays(nextQueue, top);
                return {
                    queue: nextQueue,
                    renderPage: utils_2.RenderPage.Center
                };
            });
        };
        _this.onOneRowBack = function () {
            _this.setState(function () {
                return {
                    renderPage: utils_2.RenderPage.Left
                };
            }, function () {
                setTimeout(function () {
                    _this.onQueueBack();
                }, 1000);
            });
        };
        _this.onOneRowNext = function () {
            _this.setState(function () {
                return {
                    renderPage: utils_2.RenderPage.Right
                };
            }, function () {
                setTimeout(function () {
                    _this.onQueueNext();
                }, 1000);
            });
        };
        _this.renderCards = function (products) {
            var _a = _this.props, prm = _a.prm, spm = _a.spm, customUI = _a.customUI, placeholderBg = _a.placeholderBg, col = _a.col, rowGap = _a.rowGap, columnGap = _a.columnGap;
            return (React.createElement(styled_1.OnePageProduct, { rowGap: rowGap, columnGap: columnGap, col: col }, products.map(function (ele, index) {
                return (React.createElement(Card_1.TomatoCardItem, __assign({ key: (ele === null || ele === void 0 ? void 0 : ele.gpid) + "_" + index, product: ele, customUI: customUI, prm: __assign(__assign({}, prm), { position: index }), spm: spm, placeholderBg: placeholderBg }, utils_1.getTomatoWidth(col, customUI))));
            })));
        };
        _this.state = {
            queue: _this.props.products,
            step: utils_2.getStep(_this.props.col, _this.props.row),
            renderPage: utils_2.RenderPage.Center
        };
        return _this;
    }
    SlideTomato.prototype.render = function () {
        var _a = this.state, renderPage = _a.renderPage, queue = _a.queue, step = _a.step;
        var onlyOnePage = step >= queue.length;
        return (React.createElement(styled_1.SlideContainer, null,
            React.createElement(styled_1.SlideBox, null,
                React.createElement(Arrow_1.LeftArrow, { onClick: this.onOneRowBack }),
                React.createElement(styled_1.PureProduct, { translate: onlyOnePage ? utils_2.RenderPage.NoTrans : renderPage }, onlyOnePage ? (React.createElement(React.Fragment, null, this.renderCards(queue))) : (React.createElement(React.Fragment, null,
                    this.renderCards(queue.slice(-step)),
                    this.renderCards(queue.slice(0, step)),
                    this.renderCards(queue.slice(step, step * 2))))),
                React.createElement(Arrow_1.RightArrow, { onClick: this.onOneRowNext }))));
    };
    return SlideTomato;
}(React.Component));
exports.SlideTomato = SlideTomato;
